import hand from 'marketing-website/media/images/pages/pop/share/hand@2x.png';
import planes from 'marketing-website/media/images/pages/pop/share/planes@2x.png';
import shareiOS from 'marketing-website/media/images/pages/pop/share/share-ios@2x.png';
import stars from 'marketing-website/media/images/pages/pop/share/stars@2x.png';

const assets = {
  hand: {
    alt: 'Black hand',
    maxWidth: 485,
    src: hand,
    hasShadow: false,
  },
  planes: {
    alt: 'Paper planes illustration',
    maxWidth: 180,
    src: planes,
    hasShadow: false,
  },
  shareiOS: {
    alt: 'Sharing on iOS',
    maxWidth: 560,
    src: shareiOS,
    hasShadow: false,
  },
  stars: {
    alt: 'Star, square and circle',
    maxWidth: 89,
    src: stars,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/pop/share.js